import { CircleOfFifthsFull } from '@components/CircleOfFifthsFull';
import { ModeDropdown } from '@components/ModeDropdown';
import styles from './KeyModeSelector.module.css';

interface KeyModeSelectorProps {
  onSelect?: (keyId: string) => void;
}

export function KeyModeSelector({ onSelect }: KeyModeSelectorProps) {
  return (
    <div className={styles.selector}>
      <CircleOfFifthsFull onSelect={onSelect} />
      <div className={styles.modeRow}>
        <span className={styles.modeLabel}>Mode</span>
        <ModeDropdown />
      </div>
    </div>
  );
}
